import constants from './ApartmentViewConstants';


const initialState = {
    viewing: null,
    calendar: {
        badDays: [],
        goodDays: [],
    },
    tempReservation: {
        daysId: [],
        aptId: null,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
    case constants.VIEW_APARTMENT: {
        return Object.assign({}, state, { viewing: action.payload });
    }
    case constants.CLEAR_VIEWING_APARTMENT: {
        return Object.assign({}, state, { viewing: null });
    }
    case constants.SET_BAD_CALENDAR_DAYS: {
        return Object.assign({}, state, { calendar: { badDays: action.payload, goodDays: state.calendar.goodDays } });
    }
    case constants.SET_GOOD_CALENDAR_DAYS: {
        return Object.assign({}, state, { calendar: { badDays: state.calendar.badDays, goodDays: action.payload } });
    }
    case constants.SET_TEMP_RESERVATION: {
        return Object.assign({}, state, { tempReservation: { daysId: action.payload.daysId, aptId: action.payload.aptId } });
    }
     case constants.CLEAR_TEMP_RESERVATION: {
        return Object.assign({}, state, { tempReservation: { daysId: [], aptId: null } });
    }
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/containers/ApartmentView/ApartmentViewReducer.js